export default __webpack_public_path__ + "media/titles/title_3_locale_da-9ffb8790.png";